import * as React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    errorMessage: string;
    refreshButtonText?: string;
    onRefreshCallBack?: any;
    closeButtonText?: any;
    onCloseButtonCallBack?: any;
}

const SSNSystemErrorComponent: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();

    let strRefreshButtonText = "Refresh";

    // set default value for props, if not passed
    if (props.refreshButtonText != null) {
        strRefreshButtonText = props.refreshButtonText;
    }

    const onRefresh = () => {
        if (props.onRefreshCallBack != null) {
            props.onRefreshCallBack({ status: "success", data: "refresh" });
        }
    };

    const onClose = () => {
        if (props.onCloseButtonCallBack != null) {
            props.onCloseButtonCallBack({ status: "success", data: "close" });
        }
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <h3 className="box-title">{tLang("dashboard.creditScore.ssnSystemErrorComp.title")}</h3>
            </div>
            <div className="dialog-body">
                <div className="box-description">
                    <p>{props.errorMessage}</p>
                </div>
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    {props.closeButtonText != null && (
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => onClose()}>
                                <span className="btn-text">{props.closeButtonText}</span>
                            </button>
                        </div>
                    )}
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={onRefresh}>
                            <span className="btn-text">{strRefreshButtonText}</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default SSNSystemErrorComponent;
